import { render } from "./SpeakerButton.vue?vue&type=template&id=24e63697&scoped=true"
import script from "./SpeakerButton.vue?vue&type=script&lang=js"
export * from "./SpeakerButton.vue?vue&type=script&lang=js"

import "./SpeakerButton.vue?vue&type=style&index=0&id=24e63697&scoped=true&lang=css"

import exportComponent from "/home/runner/work/abdc-frontend/abdc-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24e63697"]])

export default __exports__